import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'
import {
  PhysicalProductItemEditType,
  ProductDownloadItemEditType,
  ProductECourseItemEditType,
  ProductItemUpdateType,
} from 'modules/stores/store/content/product/types/product-interface'
import { getComplexItemUpdateData } from 'modules/stores/store/utils/get-complex-item-update-data'

namespace getItemUpdateData {
  export interface Props<T> {
    item: T
    digitalProductId?: DigitalProductId
    physicalProductId?: number
    offerId?: number
  }
}

export const getItemUpdateData = <
  ItemType extends
    | ProductDownloadItemEditType
    | ProductECourseItemEditType
    | PhysicalProductItemEditType,
>({
  item,
  digitalProductId,
  physicalProductId,
  offerId,
}: getItemUpdateData.Props<ItemType>): ProductItemUpdateType => {
  const baseItemToUpdate = getComplexItemUpdateData(item)
  const { checkoutPage, thankYouPage, productType, ...itemToUpdate } = baseItemToUpdate
  const { fields, cover, path, id, ...checkoutPageToUpdate } = checkoutPage
  const { text, title } = thankYouPage
  return {
    ...itemToUpdate,
    checkoutPage: {
      ...checkoutPageToUpdate,
      fields: item.checkoutPage.fields.map(({ slug, required }) => ({ slug, required })),
      coverId: item.checkoutPage.cover?.id ?? null,
      digitalProductId: digitalProductId ?? checkoutPageToUpdate.digitalProductId,
      physicalProductId: physicalProductId ?? checkoutPageToUpdate.physicalProductId,
      offerId: offerId ?? checkoutPageToUpdate.offerId,
    },
    thankYouPage: {
      title,
      text,
    },
  }
}
